import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import FormaPagamentoService from "service/fiscal/FormaPagamentoService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const formaPagamentoService = new FormaPagamentoService();

export default function FormaPagamentoListagem() {
    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        descricao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="codigoInterno,ASC" service={formaPagamentoService} urlService="/formaPagamento"
            tituloPagina="Formas de pagamento" defaultFilters={defaultFilters} showClearFilterButton nome="formaPagamento">
            <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativa" header="Ativo" body={(rowData) => rowData.ativa ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
